// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Account: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 41" enableBackground="new 0 0 36 41" xmlSpace="preserve" color="currentColor" fill="currentColor">
<g>
	<path d="M32.77,26.17l-7.43-5.99c0.4-0.56,0.77-1.17,1.07-1.85c0.94-2.09,1.28-4.34,1.3-6.38l0-1.42c-0.02-5.38-1.7-8.76-7.26-9.85
		c-1.3-0.25-2.64-0.29-3.94-0.09l-0.56,0.1C11.97,1.47,9.8,3.76,9.05,7.07c-0.22,0.96-0.3,1.75-0.33,2.97l-0.03,1.7l0,0.3
		c0.03,2.08,0.4,4.37,1.37,6.45c0.28,0.61,0.62,1.16,0.99,1.67l-7.67,6.02l-0.22,0.18c-1.72,1.5-2.65,4.71-2.69,8.81
		c-0.03,3.63,0.98,4.9,4.77,5.25l0.68,0.05c0.12,0.01,0.24,0.01,0.36,0.02l0.76,0.03l14.7,0.02l7.26-0.02l0.53-0.01l0.73-0.03
		l0.68-0.05c3.79-0.35,4.8-1.62,4.77-5.25C35.66,30.9,34.65,27.59,32.77,26.17z M11.77,11.71l0.01-0.55l0.01-0.61l0.02-0.7l0.03-0.6
		c0.03-0.37,0.06-0.69,0.12-1.01l0.1-0.48c0.5-2.17,1.77-3.51,4.49-4.05c1.08-0.22,2.21-0.22,3.31,0c3.76,0.74,4.76,2.74,4.77,6.82
		l0,1.41c-0.01,1.64-0.3,3.51-1.03,5.14c-1.03,2.3-2.7,3.56-5.4,3.56c-1.62,0-2.86-0.46-3.83-1.32c-0.05-0.05-0.1-0.1-0.15-0.14
		c-0.55-0.53-1-1.19-1.37-1.98c-0.75-1.61-1.06-3.5-1.08-5.16L11.77,11.71z M32.61,36.22l-0.02,0.25c-0.06,0.54-0.28,0.75-0.95,0.85
		l-0.32,0.04l-0.38,0.03L30.5,37.4l-1.45,0.04l-14.6,0.02L7.5,37.44l-1.6-0.03l-0.7-0.03l-0.38-0.03l-0.32-0.04l-0.26-0.05
		c-0.43-0.11-0.61-0.31-0.67-0.69l-0.03-0.23c0-0.04-0.01-0.08-0.01-0.13l-0.01-0.29l0.01-1.16c0.09-3.18,0.82-5.47,1.7-6.14l8-6.28
		c1.35,0.88,2.99,1.37,4.94,1.37c1.94,0,3.57-0.49,4.92-1.37l7.75,6.25l0.12,0.1c0.9,0.84,1.59,3.24,1.62,6.5l0.01,0.56L32.61,36.22
		z"/>
	<path d="M27.63,30.53H21.7l-0.18,0.01c-0.77,0.09-1.36,0.74-1.36,1.53c0,0.85,0.69,1.54,1.54,1.54h5.93l0.18-0.01
		c0.77-0.09,1.36-0.74,1.36-1.53C29.17,31.22,28.48,30.53,27.63,30.53z"/>
</g>
</svg>;
};

export default React.memo(Account);
